import {IHttpResponse} from './Service';
import {AuthenticatedService} from './AuthenticatedService';
import {Page} from '../Models';

export interface Image {
  id: number;
  type: string;
}

export class ImageService extends AuthenticatedService {
  public list = async (page: number = 1): Promise<IHttpResponse<Page<Image>>> => {
    const images = await this.getAuth<Page<Image>>(
      `images?page=${page}`,
    );

    return images;
  }

  public create = async (file: File): Promise<IHttpResponse<Image>> => {
    const formData = new FormData();
    formData.append('file', file);

    const newImage = await this.postFormAuth<Image>(
      'images', formData,
    );

    return newImage;
  }

  public update = async (): Promise<void> => {
  }

  public remove = async (id: number): Promise<IHttpResponse<Image>> => {
    const newImage = await this.deleteAuth<Image>(
      `images/${id}`,
    );

    return newImage;
  }

  public link = (id: number): string => {
    return `${this.config.BaseUrl}/images/${id}`;
  }
}
